import { render, staticRenderFns } from "./column-graph.vue?vue&type=template&id=0a299566&scoped=true&"
import script from "./column-graph.vue?vue&type=script&lang=js&"
export * from "./column-graph.vue?vue&type=script&lang=js&"
import style0 from "./column-graph.vue?vue&type=style&index=0&id=0a299566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a299566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a299566')) {
      api.createRecord('0a299566', component.options)
    } else {
      api.reload('0a299566', component.options)
    }
    module.hot.accept("./column-graph.vue?vue&type=template&id=0a299566&scoped=true&", function () {
      api.rerender('0a299566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/box-desempenho-carteira/column-graph.vue"
export default component.exports